import { BASE_URL } from '@constants/api'
import {
	AddCategoriesRequest,
	ListCategoriesRequest,
	ListCategoriesResponse,
	ReorderCategoriesRequest,
	ShowCategoriesResponse,
	UpdateCategoriesRequest,
} from '@models/categories.model'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setAuthorization } from '@utils/helpers'

export const categoriesApi = createApi({
	reducerPath: 'categoriesTurmaApi',
	tagTypes: ['Categories'],
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: setAuthorization,
	}),
	endpoints: (builder) => ({
		list: builder.query<ListCategoriesResponse, ListCategoriesRequest>({
			// Sem `page`: a API devolve a lista inteira, que é o que o arrasto de
			// ordenação precisa enxergar para mover uma categoria a qualquer posição.
			query: ({ search = '' }) => ({
				url: `/categories?search=${search}`,
				method: 'GET',
			}),
			providesTags: ['Categories'],
		}),
		show: builder.mutation<ShowCategoriesResponse, { id: number }>({
			query: ({ id }) => ({
				url: `/categories/${id}`,
				method: 'GET',
			}),
		}),
		add: builder.mutation<void, AddCategoriesRequest>({
			query: (newData) => {
				const formData = new FormData()

				formData.append('name', newData.name)
				formData.append('image', newData.image ? newData.image[0] : '')

				return {
					url: `/categories`,
					body: formData,
					method: 'POST',
				}
			},
			invalidatesTags: ['Categories'],
		}),
		edit: builder.mutation<void, UpdateCategoriesRequest>({
			query: ({ id, ...data }) => {
				const formData = new FormData()

				formData.append('name', data.name)
				formData.append('image', data.image ? data.image[0] : '')

				return {
					url: `/categories/${id}`,
					body: formData,
					method: 'PUT',
				}
			},
			invalidatesTags: ['Categories'],
		}),
		reorder: builder.mutation<void, ReorderCategoriesRequest>({
			query: ({ categoryId, newPosition }) => ({
				url: `/categories/reorder`,
				body: {
					categoryId,
					newPosition,
				},
				method: 'POST',
			}),
			invalidatesTags: ['Categories'],
		}),
		delete: builder.mutation<void, { id: number }>({
			query: ({ id }) => ({
				url: `/categories/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Categories'],
		}),
	}),
})
